import { fromPairs } from "lodash";

// Mixed
export { MixedWidget1 } from "./mixed/MixedWidget1";
export { MixedWidget4 } from "./mixed/MixedWidget4";
export { MixedWidget6 } from "./mixed/MixedWidget6";
export { MixedWidget10 } from "./mixed/MixedWidget10";
export { MixedWidget11 } from "./mixed/MixedWidget11";
export { MixedWidget12 } from "./mixed/MixedWidget12";
export { MixedWidget14 } from "./mixed/MixedWidget14";

// Lists
export { ListsWidget1 } from "./lists/ListsWidget1";
export { ListsWidget3 } from "./lists/ListsWidget3";
export { ListsWidget4 } from "./lists/ListsWidget4";
export { ListsWidget8 } from "./lists/ListsWidget8";
export { ListsWidget9 } from "./lists/ListsWidget9";
export { ListsWidget10 } from "./lists/ListsWidget10";
export { LicensesWidget } from "./lists/LicensesWidget";
export { LicensesWidgetTwo } from "./lists/LicensesWidgetTwo";
export { ListsWidget14 } from "./lists/ListsWidget14";

export { ReviewsWidget } from './tiles/ReviewsWidget'
// Stats
export { StatsWidget10 } from "./stats/StatsWidget10";
export { IncomeChartWidget } from "./stats/IncomeChartWidget";
export { StatsWidget12 } from "./stats/StatsWidget12";

// Base tables
export { BaseTablesWidget1 } from "./base-tables/BaseTablesWidget1";
export { BaseTablesWidget2 } from "./base-tables/BaseTablesWidget2";
export { LastestOrdersWidget } from "./base-tables/LastestOrdersWidget";
export { BestSaleWidget } from "./base-tables/BestSaleWidget";

// Advance tables

export { AdvanceTablesWidget2 } from "./advance-tables/AdvanceTablesWidget2";
export { AdvanceTablesWidget4 } from "./advance-tables/AdvanceTablesWidget4";
export { AdvanceTablesWidget9 } from "./advance-tables/AdvanceTablesWidget9";

// Tiles
export { TilesWidget1 } from "./tiles/TilesWidget1";
export { TilesWidget3 } from "./tiles/TilesWidget3";
export { TilesWidget10 } from "./tiles/TilesWidget10";
export { TilesWidget11 } from "./tiles/TilesWidget11";
export { TilesWidget12 } from "./tiles/TilesWidget12";
export { TilesWidget13 } from "./tiles/TilesWidget13";
export { TilesWidget14 } from "./tiles/TilesWidget14";
export { DispensaryProductsCountTile } from "./tiles/DispensaryProductsCountTile"
export { DispensaryFulfilledOrdersCountTile } from "./tiles/DispensaryFulfilledOrdersCountTile"

export { MyLocationWidget } from './maps/MyLocationWidget'
export { LocationWidget } from './maps/LocationWidget'
export { AreaOfCoverageWidget } from './maps/AreaOfCoverageWidget'
export { UserNotesWidget } from './notes/UserNotesWidget'
export { SubscriptionWidget } from './base-tables/SubscriptionWidget'

export { QrCodeScannerModal } from './scanner/QrCodeScannerModal'


// LandingBuilder 

export { FeatureLanding } from './landingBuilder/Feature'
export { MainSectionLanding } from './landingBuilder/MainSection'
export { TextSectionLanding } from './landingBuilder/TextSection'

export { RecentReviews } from './base-tables/RecentReviews'